
export const DEFAULT_LOCALE = 'ru';
export const MIN_PASSWORD_LENGTH = 8;
